





















































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { AgencyFeeModel, AgencyFeesPropertyModel, AgencyFeesPropertyRequest } from "@/shared/models/agencyFee";
import { Action, Getter } from "vuex-class";
import { Currency } from "@/shared/models/currency";
import { CalculationMethods, PriceCalculationMethodView } from "@/shared/models/priceCalculationMethods";
import { DataOptions } from "vuetify";
import { ListModel } from "@/shared/models/listModel";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { Notification } from "@/store/modules/notifications";
import _ from "lodash";
import NoData from "../misc/NoData.vue";
import FormDescription from "@/components/misc/FormDescription.vue";
import NumericInputImproved from "../numbers/NumericInputImproved.vue";
   
@Component({
  components: {
    NoData,
    NumericInputImproved,
    FormDescription
  },
})

export default class PropertyFormAgencyFeeSelection extends Vue {
  @PropSync("open") internalOpen?: boolean;
  @PropSync("selectedAgencyFees") internalSelectedAgencyFees?: AgencyFeesPropertyModel[];
  @Prop() propertyId?: number;

  @Action("codebooks/refreshCurrencies") refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];
  // prettier-ignore
  @Action("codebooks/refreshPriceCalculationMethods") refreshPriceCalculationMethods?: () => Promise<void>;
  // prettier-ignore
  @Getter("codebooks/priceCalculationMethods") priceCalculationMethods?: PriceCalculationMethodView[];

  agencyFeesToAdd = [] as AgencyFeeModel[];

  agencyFeeheaders = [
    {
      text: "AgencyFee.Name",
      value: "name"
    },
    {
      text: "AgencyFee.Price",
      value: "price"
    },
    {
      text: "AgencyFee.CalculationMethod",
      value: "calculationMethodId"
    }
  ];

  @Watch("internalOpen", { immediate: true })
  async openWatch(fresh: boolean) {
    if (fresh && this.propertyId) {
      this.agencyFeesToAdd = []
      await this.load();
    } 
  }

  manualMethod(){
    const manualMethod = this.priceCalculationMethods?.find(method => method.id === CalculationMethods.Manual);
    if(manualMethod){ 
      manualMethod.textResourceKey = this.$t("t.PriceCalculationMethods.FixedAmount").toString();
    }
  }

  async created() {
    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      await this.refreshCurrencies();
    }

    if (
      (this.priceCalculationMethods?.length ?? 0) === 0 && this.refreshPriceCalculationMethods) {
      await this.refreshPriceCalculationMethods();
    }
    this.manualMethod();
  }

  filters = {
    name: "",
  };

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["name"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

 initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  loading = true;
  list: ListModel<AgencyFeeModel> = {
    count: 0,
    result: [],
  };

  debouncedLoad = _.debounce(this.load, 500);
  
  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      zeroOrPositive: (value: any) =>
        +value >= 0 || this.$t("Validation.MustBeZeroOrPositive"),
      maxDecimals: (value: any) =>
        !(this.countDecimals(+value) > 2) ||
        this.$t("Validation.CanOnlyHaveTwoDecimals"),
    };
  }
  get decimalSeparator() {
    const separator = Intl.NumberFormat(this.internalLanguage)
      .format(1.1)
      .replace(/\p{Number}/gu, "");
    return separator;
  }

  countDecimals(num: number) {
    return num.toString().split(this.decimalSeparator)[1]?.length || 0;
  }

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  @Getter("language/language") language?: string;
  get cultureCode(){
    return this.language ?? "hr-HR";
  }
  async load(): Promise<ListModel<AgencyFeeModel>>{
    this.loading = true;

    return (
      this.axios
        .get<ListModel<AgencyFeeModel>>("/AgencyFees/GetAvailableAgencyFeesForProperty/", {
        params: {
          propertyId: this.propertyId,
          cultureCode: this.cultureCode,
        }})
        .then((res) => {
          this.list = res.data;
          return this.list;
        })
        .finally(() => (this.loading = false))
    );
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filters,
      excludeBookingFee: true
    };
  }

  get translatedAgencyFeeHeaders() {
    return this.agencyFeeheaders.map((x) => ({
      ...x,
      text: this.$t(x.text),
    }));
  }

  getCurrencyCode(currencyId: number) {
    return this.currencies?.find((x) => x.id == currencyId)?.isoCode;
  }
  
  getPriceCalculationMethodText(priceCalculationMethodId: number){
    return this.$t(this.priceCalculationMethods?.find(x => x.id == priceCalculationMethodId)?.textResourceKey || '');
  }

  areAllAgencyFeesSelected() {
    return !this.list.result.some(
      (e) => this.agencyFeesToAdd?.indexOf(e) === -1
    );
  }

  isFormValid = false;
  get submitDisabled(): boolean {
    return this.isFormValid && !this.loading;
  }

  selectAgencyFees() {
    if (this.areAllAgencyFeesSelected()) {
      this.agencyFeesToAdd = [];
    } 
    else {
      const unselected = this.list.result.filter(
        (e) => this.agencyFeesToAdd.indexOf(e) === -1
      );
      this.agencyFeesToAdd = this.agencyFeesToAdd.concat(unselected);
    }
  }

  fees = new AgencyFeesPropertyRequest();
  saving = false;

  popupForReservationUpdate() {
    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t("PropertyAgencyFee.ApplyToFutureReservations"),
      actions: [
        {
          text: this.$t("Yes"),
          fun: () => {
            this.addSelectedAgencyFeesToProperty(true);
            return true;
          },
        },
        {
          text: this.$t("No"),
          fun: () => {
            this.addSelectedAgencyFeesToProperty(false);
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  async addSelectedAgencyFeesToProperty(updateReservations: boolean){
    this.saving = true;
    this.fees.propertyId = this.propertyId ?? 0;
    this.fees.agencyFeesProperty = this.agencyFeesToAdd;
    this.fees.updateReservations = updateReservations;

    this.$emit("addAgencyFee", this.fees);
  }
}
